import { withErrorBoundary } from '../modules/error-boundary';

const Children = ({ children, location }) => children({ location });

export default withErrorBoundary(Children);
